/**
 * Business Card Manager Product Data
 *
 * @deprecated - This file uses the legacy structure with hybrid merge approach.
 * MIGRATION PENDING: Will be migrated to JSON translations structure.
 * See: public/locales/en/products/tadreamk-eye.json for the new pattern.
 *
 * For now, this product continues to work using the old translation pattern.
 */

import businessCardImage from "../../assets/images/products/Business card management.webp";
import { APP_CONFIG } from "../../configs/config";
import {
  FEATURE_ICONS,
  STATUS_ICONS,
  CONTENT_ICONS,
} from "../../configs/emojis";

const businessCardManagerData = {
  id: 6,
  image: businessCardImage,
  title: "Business Card Manager",
  category: "AI Services",
  imageAlt: "AI business card digitization and management",
  abstract:
    "Scan, digitize, and manage business cards effortlessly. Organize contacts, extract information instantly with AI, and build your professional network efficiently.",
  ctaUrl: APP_CONFIG.BUSINESS_CARD_SERVICE_URL,
  ctaText: "Scan & Manage Cards",
  primaryFeatureTag: "Business Card Manager",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: FEATURE_ICONS.AI,
      title: "AI‑powered capture",
      text: "Point your camera at any business card—glossy, textured, folded, or photographed in the moment—and our pipeline corrects perspective, removes glare, denoises, balances lighting, and rescales automatically. A multilingual OCR engine extracts text across Latin and non‑Latin scripts while logo detection and color sampling preserve brand context. Images are processed on secure infrastructure with privacy‑first defaults, so you get clean, structured records in seconds without babysitting the scan.",
    },
    {
      icon: CONTENT_ICONS.BULB,
      title: "Field understanding",
      text: "Beyond raw OCR, our models understand business‑card semantics: full names and honorifics, roles and seniority, company entities, phone numbers, emails, postal addresses, websites, and social handles. We normalize international formats (E.164 phones, RFC email checks), validate with checksum and regex heuristics, and auto‑enrich where permitted. Duplicate detection, canonicalization, and confidence scores reduce manual edits and keep your contact graph clean and searchable.",
    },
    {
      icon: FEATURE_ICONS.ROCKET,
      title: "Instant workflows",
      text: "Export to your CRM, sync to spreadsheets, or share with teammates in one tap. Batch import stacks after events, tag leads, and automatically de‑duplicate against existing contacts. Create reminders, assign owners, and attach meeting context so follow‑ups happen on time. Offline queueing and background sync keep momentum even when you are moving between sessions or venues.",
    },
    {
      icon: STATUS_ICONS.INFO,
      title: "Built for productivity",
      text: "This page demonstrates TadReamk’s applied AI for document capture and contact management. It is designed to accelerate networking and data entry rather than replace legal review or compliance processes. Treat outputs as high‑quality suggestions that speed expert workflows. Data is handled with care—encryption in transit and at rest, role‑based access, and user controls that let you export or delete your information whenever needed.",
    },
  ],
};

export default businessCardManagerData;
